import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZDeviceListDetails = z.object({
  id: z.string(),
  name: z.string(),
  deviceTypeId: z.string()
})

export const ZData = z.object({
  total_count: z.number(),
  site_id: z.string(),
  devices: ZDeviceListDetails.array()
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.optional(ZData)
})

export type DeviceListDetails = z.infer<typeof ZDeviceListDetails>
export type DeviceParameterAPIData = z.infer<typeof ZApiResponse>

export async function getDeviceListData (
  siteId: string,
  assetId: string,
  onSuccess: (DeviceListData: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/assetrest/api/v2/udp/tiq/assets/getAssetsAndDevices?siteId=${siteId}&assetId=${assetId}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
